import { createContext } from '@shared/utils/createContext';
import type { EventDesignThemingProviderContext } from './types.internal';

const [EventDesignThemingContextProvider, useEventDesignThemingProvider] = createContext<EventDesignThemingProviderContext>({
  name: 'EventDesignThemingProvider',
});

export { EventDesignThemingContextProvider, useEventDesignThemingProvider };
